import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { LeaderboardConainer } from './style';
//actions
//Components
import { LeaderboardCard } from '../../Components/LeaderboardCard/LeaderboardCard';
import { BannerEmptyStatsLeaderboards } from '../../Components/BannerEmptyStats/BannerEmptyStats';
//Containers
import SelectionForLeaderBoards from '../../Containers/SelectionForLeaderBoards/SelectionForLeaderBoards';

import { getId } from '../../../Utils';
import { Loading } from '../WithLoading/Loading';
import { EmptyState } from '../WithEmptyState/EmptyState';
import { LeaderboardsActionCreators } from '../../../Store/ActionCreators/LeaderboardsActionCreators';

class LeaderBoards extends Component {
    componentDidMount() {
        this.props.getLeaderboardsList();
    }

    loadMoreLeaderboards = lastLeaderboardId => {
        const { loadMoreLeaderboards, match, leaderboards } = this.props;
        const paginationOffset = leaderboards[leaderboards.length - 1].id;

        if (match.params.workoutId) {
            loadMoreLeaderboards(paginationOffset);
        } else {
            loadMoreLeaderboards(paginationOffset);
        }
    };

    componentWillUnmount() {
        this.props.resetScroll();
    }

    render() {
        const {
            leaderboards,
            moreLeaderboardsToLoad,
            userMetric,
            areLeaderboardsLoading,
            onSelect,
            selectLeaderboardType,
            initialModalType,
        } = this.props;
        const areLeaderboardsEmpty = leaderboards.length === 0;

        // todo: make leaderboard card dumb
        return (
            <Loading isLoading={areLeaderboardsLoading}>
                <EmptyState isEmpty={areLeaderboardsEmpty} emptyState={BannerEmptyStatsLeaderboards}>
                    <LeaderboardConainer center={onSelect} className="leaderboard">
                        <SelectionForLeaderBoards
                            isCentered={onSelect}
                            loadMoreLeaderboards={this.loadMoreLeaderboards}
                            moreLeaderboardsAvailable={moreLeaderboardsToLoad}
                            leaderboardsLength={leaderboards.length}
                            selectLeaderboardType={selectLeaderboardType}
                            onLeaderboardsSelect={onSelect}
                            initialModalType={initialModalType}
                        >
                            {leaderboards.map((leaderboard, index) => (
                                <LeaderboardCard
                                    onLeaderboardSelect={onSelect}
                                    selectLeaderboardType={selectLeaderboardType}
                                    initialModalType={initialModalType}
                                    key={index}
                                    {...leaderboard}
                                    userMetric={userMetric}
                                />
                            ))}
                        </SelectionForLeaderBoards>
                    </LeaderboardConainer>
                </EmptyState>
            </Loading>
        );
    }
}

const mapStateToProps = ({ leaderboards, user: { currentUserPreferences } }) => ({
    leaderboards: leaderboards.leaderboardsList,
    areLeaderboardsLoading: leaderboards.statuses.isLeaderboardsListLoading,
    moreLeaderboardsToLoad: leaderboards.moreLeaderboardsToLoad,
    userMetric: currentUserPreferences.metric,
});

const mapDispatchToProps = (dispatch, { specificProfileId, specificWorkoutId, match }) => {
    const profileId = match.params.profileId ? getId(match.params.profileId) : specificProfileId;
    const workoutId = match.params.workoutId || specificWorkoutId;

    return {
        getLeaderboardsList() {
            if (match.params.workoutId || specificWorkoutId) {
                dispatch(LeaderboardsActionCreators.getWorkoutLeaderboardsRequest(workoutId));
            } else {
                dispatch(LeaderboardsActionCreators.getProfileLeaderboardsRequest({ profileId }));
            }
        },
        loadMoreLeaderboards(paginationOffset) {
            if (match.params.workoutId) {
                dispatch(
                    LeaderboardsActionCreators.loadMoreWorkoutLeaderboardsRequest({
                        workoutId,
                        paginationOffset,
                    }),
                );
            } else {
                dispatch(
                    LeaderboardsActionCreators.loadMoreProfileLeaderboardsRequest({
                        profileId,
                        paginationOffset,
                    }),
                );
            }
        },
        resetScroll() {
            dispatch({ type: 'RESET_LEADERBOARDS_SCROLL' });
        },
    };
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    withRouter,
)(LeaderBoards);



// WEBPACK FOOTER //
// ./src/UI/Containers/LeaderBoards/LeaderBoards.js